export default "__VITE_ASSET__CoTn6yD0__"